module.exports = __webpack_public_path__ + "img/Deathknight-troll-f-70.d7b46b1f.gif";